<template>
    <div class="dvBodyTree scroll-thin-custom" >
    <Tree :value="menuFilter" selectionMode="single" @nodeSelect="onNodeSelect">
        <template #default="slotProps">
            <div class="p-treenode-content" >
                <span class="p-treenode-label" v-if="!smallMode">
                    {{ $t(`menus.menu_${slotProps.node.label}`)}}
                </span>                               
            </div>                           
        </template>
        <template #fontawesome="slotProps">  
            <div class="p-treenode-content" style="margin-left: -15px;">                
                <span class="p-treenode-icon">
                    <font-awesome-icon :icon="slotProps.node.icon.split(' ')"   /> 
                </span> 
                
                <span class="p-treenode-label" v-if="!smallMode">
                    {{ $t(`menus.menu_${slotProps.node.label}`)}}
                </span>             
            </div>
        </template>          
    </Tree>    
    </div>
</template>
<script  setup lang="ts">
import { useServicesFactoryStore } from '@/core/stores/services-factory-store';
import Tree from 'primevue/tree';
import { PropType, defineProps, defineEmits, computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { TreeNode } from 'primevue/treenode';
import AppUIManagerService from '@/core/services/AppUIManagerService';
import { useRouter } from 'vue-router';

const props = defineProps(
{
 go: Boolean,
 menus: { type: Array as PropType<any>, required:true },
 smallMode:Boolean
});
const emit = defineEmits(['onClickMenu']);
const router = useRouter();
const uiManager:AppUIManagerService = useServicesFactoryStore().getAppUIManagerService;
const menuFilter = computed(()=>
{
    const filteredMenus = new Array<any>();
    if(props.menus && props.menus.length > 0)
    {
        for (const menu of props.menus)
        {
          filteredMenus.push(menu);
        }
    }
    return filteredMenus;
});
const onNodeSelect= (node : TreeNode) =>
{    
    uiManager.ReloadCurrentAction = null;
    if(node &&  node.data && node.data.url)
    {
        if(props.go)
        {            
            router.replace({ name: node.data.url });
        }
        uiManager.ActiveMenu.next(node);
        emit('onClickMenu',node);
    }
}
</script>